import { CRM_USER_INFO, CRM_CURRENT_LEVEL_ONE_MENU, CRM_CURRENT_SUBMENU, CRM_MENU } from '../util/keys';
import ToolTip from '../plugins/crmTooltip/index';

export default {
    install(Vue, options) {
        Vue.component(ToolTip.name, ToolTip)
        Vue.prototype.$kiko_tooltip = ToolTip.installToolTip
        Vue.prototype.unlocking = (key) => {
            let userInfo = localStorage.getItem(CRM_USER_INFO);
            userInfo = JSON.parse(userInfo);
            if (userInfo) {
                var { SysFunctions } = userInfo;
            }
            if (key instanceof Array) {
                let operation = false;
                for (var j in key) {
                    for (var i in SysFunctions) {
                        if (key[j] == SysFunctions[i].FunctionKey) {
                            operation = true;
                            break;
                        }
                    }
                }
                return operation;
            }
            for (var i in SysFunctions) {
                if (SysFunctions[i].FunctionKey == key) {
                    return true;
                }
            }
            return false;
        }
        Vue.prototype.printClass = (key) => {
            let userInfo = localStorage.getItem(CRM_USER_INFO);
            let print = '';

            userInfo = JSON.parse(userInfo);
            if (userInfo) {
                var { SysFunctions } = userInfo;
            }
            if (key instanceof Array) {
                for (var j in key) {
                    for (var i in SysFunctions) {
                        if (key[j] == SysFunctions[i].FunctionKey) {
                            // 客户管理页
                            if (key[j] == 'CM_FollowClue') { print += 'CM_FollowClue ' }
                            if (key[j] == 'CRM_ClueFollow_ModifyInfo') { print += 'CRM_ClueFollow_ModifyInfo ' }
                            if (key[j] == 'CM_Sign up') { print += 'CM_Sign_up ' }
                            if (key[j] == 'CM_SearchShareClue') { print += 'CM_SearchShareClue ' }
                            if (key[j] == 'CM_ListenInvitation') { print += 'CM_ListenInvitation ' }
                            if (key[j] == 'CM_Sign_up') { print += 'CM_Sign_up ' }
                            if (key[j] == 'CM_SearchShareClue') { print += 'CM_SearchShareClue ' }
                            if (key[j] == 'CM_ListenInvitation') { print += 'CM_ListenInvitation ' }
                            if (key[j] == 'Clues_Modify_Contact') { print += 'Clues_Modify_Contact ' }
                            if (key[j] == 'CM_ClueDetail_WDKH') { print += 'CM_ClueDetail_WDKH ' }
                            if (key[j] == 'CM_ClueUpdate_WDKH') { print += 'CM_ClueUpdate_WDKH ' }
                            if (key[j] == 'CM_ClueSignUp_WDKH') { print += 'CM_ClueSignUp_WDKH ' }
                            if (key[j] == 'CRM_ClueKickPool') { print += 'CRM_ClueKickPool ' }

                            // 客户管理
                            if (key[j] == 'CM_FollowClue_WDKH') { print += 'CM_FollowClue_WDKH ' }
                            if (key[j] == 'CRM_MyClent_ModifyInfo') { print += 'CRM_MyClent_ModifyInfo ' }
                            if (key[j] == 'CM_Sign up_WDKH') { print += 'up_WDKH ' }
                            if (key[j] == 'CM_Sign_up_WDKH') { print += 'CM_Sign_up_WDKH ' }
                            if (key[j] == 'CM_ListenInvitation_WDKH') { print += 'CM_ListenInvitation_WDKH ' }
                            if (key[j] == 'CM_SearchShareClue_WDKH') { print += 'CM_SearchShareClue_WDKH ' }
                            if (key[j] == 'CRM_ClueKickPool_WDKH') { print += 'CRM_ClueKickPool_WDKH ' }

                            // 电邀管理-我的客户
                            if (key[j] == 'PG_Tmk_MyCustom_Edit') { print += 'PG_Tmk_MyCustom_Edit ' }
                            if (key[j] == 'PG_Tmk_MyCustom_Pool_Single') { print += 'PG_Tmk_MyCustom_Pool_Single ' }
                            if (key[j] == 'PG_Tmk_MyCustom_Following') { print += 'PG_Tmk_MyCustom_Following ' }

                        }
                    }
                }
                return print;
            }

        }
        Vue.prototype.push = ({ path, context }) => {
            let menu = JSON.parse(localStorage.getItem(CRM_MENU));
            let matchingPath = (m) => {
                for (let i in m) {
                    if (m[i].Url == path) {
                        context.$router.push({ path });
                        setTimeout(() => {
                            context.$store.dispatch('updateCurrentTabId', m[i].ParentPath[0]);
                            context.$store.dispatch('updateCurrentSubMenu', m[i].ParentPath[0]);
                        }, 0);
                        return;
                    }
                    if (m[i].ChildNavigations) {
                        matchingPath(m[i].ChildNavigations);
                    }
                }
            }
            matchingPath(menu);
        }
        Vue.prototype.getBaseUrl = () => {
            let host = location.host;
            // 开发环境
            if (host.indexOf('localhost') > -1 || host.indexOf('192') > -1) {
                return 'http://192.168.60.235:6002';
            }
            let pre = location.host.match(/^.*-/);
            // 正式环境
            if (pre === null) {
                return '//crm.songshuai.com';
            }
            // 测试及预发布环境
            return `${pre[0]}crm.songshuai.com`;
        }
    }
}